<div class="mx-auto" id="categories">
  <% if notice.present? %>
    <p class="py-2 px-3 bg-green-50 mb-5 text-green-500 font-medium rounded-lg inline-block" id="notice"><%= notice %></p>
  <% end %>

<div data-controller="info-box">
<div class="info-button">&#x24D8;</div>
<ul class="info-box">
<li>The order categories appear on this list affects the order they appear in the final agenda.  You can rearrange the order by using drag and drop.</li>
<li>Clicking a category name will let you edit that category's name and identify which dances are included in that category.</li>
</ul>
</div>

  <h1 class="text-center font-bold text-4xl mb-12">Agenda</h1>

  <% entry_count = 0 %>
  <% heat_count = 0 %>

  <div class="min-w-full">
  <table class="table-fixed ml-6 mb-8">
    <thead>
    <tr>
      <th class="row-head">Category</th>
      <th class="row-head">Entries</th>
      <th class="row-head">Heats</th>
      <% unless @categories.all? { |cat| cat.day.blank? } %>
      <th class="row-head">Day</th>
      <% end %>
    </tr>
    </thead>
    <% if @locked %>
    <tbody>
    <% else %>
    <tbody data-controller="drop" data-drop-action="<%= drop_categories_path() %>">
    <% end %>
    <% @categories.each do |cat| %>
      <% cat_entries = @cat_entries[cat.id] || 0 %>
      <% cat_heats = @cat_heats[cat.id] || 0 %>
      <% entry_count += cat_entries %>
      <% heat_count += cat_heats %>
      <tr class="hover:bg-yellow-200" draggable="true" data-drag-id="<%= cat.id %>">
        <td class="row text-black font-medium"><%= link_to cat.name, edit_category_path(cat) %></td>
        <td class="row text-right"><%= cat_entries %></td>
        <td class="row text-right"><%= cat_heats %></td>
        <% unless @categories.all? { |c| c.day.blank? } %>
        <% unless cat.day.blank? %>
        <td class="row"><%= cat.day %></td>
        <% else %>
        <td class="row"></td>
        <% end %>
        <% end %>
      </tr>
    <% end %>
    </tbody>
    <tfoot>
    <tr>
      <th class="border-t-2 border-gray-200 row text-center font-bold">total</th>
      <td class="border-t-2 border-gray-200 row text-right">
        <%= entry_count %>
      </td>
      <td class="border-t-2 border-gray-200 row text-right">
        <%= heat_count %>
      </td>
      <% unless @categories.all? { |cat| cat.day.blank? } %>
      <th class="border-t-2"></th>
      <% end %>
    </tr>
    </tfoot>
  </table>
  </div>

  <div class="mt-4 flex justify-between items-center">
    <%= link_to 'New category', new_category_path, class: "btn-blue" %>
    <%= link_to 'Dances', dances_path, class: "btn-green" %>
    <%= link_to "Back to Event", root_path, class: "btn-green" %>
  </div>
</div>
